import { render, staticRenderFns } from "./CalibrationDataTable.vue?vue&type=template&id=71b2275e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./CalibrationDataTable.vue?vue&type=style&index=0&id=71b2275e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2275e",
  null
  
)

export default component.exports